import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// P2 median advertiser — New-customers campaign.
export const campP2MedianNew: FaireAdCampaignEntity = {
  token: "camp_p2_median_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_p2_median",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 300,
  startedRunningAt: "2026-01-27",
  segmentMetrics: {
    numCustomersAcquired: 3,
    salesDollars: 1763,
    totalAdsSpendDollars: 683,
    cpaDollars: 228,
    bestEstimateSalesDollars: 1763,
    bestEstimateRoas: 2.58,
  },
  topCustomers: [
    {
      retailerName: "Willow & Fern Mercantile",
      storeType: "Home & gift",
      location: "Portland, OR",
      totalOrders: 2,
      totalAmountDollars: 612,
      lastOrderedAt: "2026-05-18",
    },
    {
      retailerName: "The Tidewater Shop",
      storeType: "Boutique",
      location: "Savannah, GA",
      totalOrders: 1,
      totalAmountDollars: 284,
      lastOrderedAt: "2026-02-11",
    },
  ],
  performancePeriodTokens: [
    "perf_p2_median_new_202602",
    "perf_p2_median_new_202603",
    "perf_p2_median_new_202604",
    "perf_p2_median_new_202605",
    "perf_p2_median_new_202606",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
